<template>
  <div>
    <van-search
      v-model:value="queryParam"
      show-action
      placeholder="请输入商品名称或商品条码"
      @search="search"
      @clear="clear"
    >
      <template #action>
        <div @click="search">搜索</div>
      </template>
    </van-search>
    <div style="margin: 6px 0; height: calc(100vh - 110px); overflow: hidden">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="已显示全部"
        ref="scrollContainer"
        @load="getList(true)"
      >
        <div v-for="item in tableData" :key="item.id" class="container">
          <div class="title">
            <span class="product-name">{{ item.productName }}</span>
            <span class="actions">
              <van-button size="mini" @click.stop="goDetail(item)"
                >变动明细</van-button
              >
              <van-button size="mini" @click.stop="openModify(item)"
                >修改</van-button
              >
            </span>
          </div>
          <div class="content">
            <div class="left">
              <div
                class="row single"
                v-for="(col, idx) in singleColumns"
                :key="'s' + idx"
              >
                <div class="item">
                  <span class="label">{{ col.title }}:</span>
                  <span class="value">{{ item[col.key] }}</span>
                </div>
              </div>
              <div
                class="row"
                v-for="(pair, idx) in restColumnPairs"
                :key="idx"
              >
                <div class="item" v-for="(el, i) in pair" :key="i">
                  <span class="label">{{ el.title }}:</span>
                  <span class="value">{{ item[el.key] }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <StockSelect
      :visible="stockSelectVisible"
      @confirm="stockSelectConfirm"
    ></StockSelect>
    <CategorySelect
      :visible="categorySelectVisible"
      @confirm="categorySelectConfirm"
    ></CategorySelect>

    <!-- 修改弹窗 -->
    <van-popup
      v-model:show="modifyVisible"
      position="bottom"
      round
      close-on-click-overlay
    >
      <div class="modify-content">
        <div class="modify-title">修改批次信息</div>
        <van-cell-group inset>
          <van-field
            v-model="modifyForm.productionDate"
            label="生产日期"
            readonly
            placeholder="请选择"
            inputmode="none"
            @click="openModifyDatePicker"
          />
          <van-field
            v-model="modifyForm.shelfLife"
            label="保质期天数"
            type="digit"
            placeholder="请输入"
          />
        </van-cell-group>
        <div class="modify-actions">
          <van-button block @click="modifyVisible = false">取消</van-button>
          <van-button
            block
            type="primary"
            :loading="modifyLoading"
            @click="confirmModify"
            >确定</van-button
          >
        </div>
      </div>
      <DateTimePicker
        :showPicker="showModifyDatePicker"
        value-format="yyyy-MM-dd"
        @confirm="onModifyDateConfirm"
        @cancel="showModifyDatePicker = false"
      ></DateTimePicker>
    </van-popup>
  </div>
</template>
<script>
import moment from "moment";
import { queryLot } from "../../../service/api/stock/product";
import { modifyLot } from "../../../service/api/stock/lot";
import CustomTable from "../../../components/customTable.vue";
import {
  PURCHASE_ORDER_STATUS,
  getTextByValue,
} from "../../../utils/constants";
import DateTimePicker from "../../../components/dateTimePicker";
import { oneMonthAgoMidnight } from "../../../utils";
import StockSelect from "../../../components/stockSelect.vue";
import CategorySelect from "../../../components/categorySelect.vue";
import { Toast } from "vant";

export default {
  name: "index",
  components: {
    CustomTable,
    CategorySelect,
    StockSelect,
    DateTimePicker,
  },
  data() {
    return {
      queryParam: "",
      formData: {},
      brandSelectVisible: false,
      categorySelectVisible: false,
      stockSelectVisible: false,
      loading: false,
      finished: false,
      showStatusPicker: false,
      action: [
        { name: "审核通过", click: "" },
        { name: "审核拒绝", click: "" },
      ],
      showActions: false,
      columns: [
        { field: "lotId", key: "lotId", title: "批次号", width: 100 },
        {
          field: "createTime",
          key: "createTime",
          title: "生成时间",
          width: 170,
        },
        {
          field: "externalCode",
          key: "externalCode",
          title: "外部编码",
          width: 100,
        },
        {
          field: "stockNum",
          key: "stockNum",
          title: "库存数量",
          align: "right",
          width: 100,
        },
        { field: "expireDate", key: "expireDate", title: "保质期", width: 100 },
        {
          field: "productionDate",
          key: "productionDate",
          title: "生产日期",
          width: 100,
        },
        {
          field: "shelfLife",
          key: "shelfLife",
          title: "保质期天数",
          width: 100,
        },
        {
          field: "numberOfDaysExpired",
          key: "numberOfDaysExpired",
          title: "过期天数",
          width: 100,
        },
      ],
      tableData: [],
      currentDate: "",
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      totalPage: 1,
      formData: {},
      key: "",
      showDatePicker: false,
      // 修改弹窗
      modifyVisible: false,
      modifyLoading: false,
      showModifyDatePicker: false,
      modifyForm: {
        id: "",
        productionDate: "",
        shelfLife: "",
      },
    };
  },
  computed: {
    statusColumns() {
      return PURCHASE_ORDER_STATUS;
    },
    // 单行展示的字段（批次号、外部编码）
    singleColumnKeys() {
      return ["lotId", "externalCode"];
    },
    singleColumns() {
      return this.columns.filter((c) => this.singleColumnKeys.includes(c.key));
    },
    // 剩余字段两两分组，实现一行两字段
    restColumnPairs() {
      const rest = this.columns.filter(
        (c) => !this.singleColumnKeys.includes(c.key),
      );
      const pairs = [];
      for (let i = 0; i < rest.length; i += 2) {
        pairs.push(rest.slice(i, i + 2));
      }
      return pairs;
    },
  },
  created() {
    this.formData.createStartTime = oneMonthAgoMidnight();
    this.formData.createEndTime = moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.onSubmit();
  },
  methods: {
    // 顶栏搜索：重置分页并刷新列表
    search() {
      this.pageIndex = 1;
      this.finished = false;
      this.tableData = [];
      this.getList();
    },
    clear() {
      this.queryParam = "";
      this.search();
    },
    categorySelectConfirm(row) {
      if (!Object.keys(row).length) {
        this.categorySelectVisible = false;
        return;
      }
      this.categorySelectVisible = false;
      this.formData.categoryName = row.name;
      this.formData.categoryId = row.id;
    },
    brandSelectConfirm(row) {
      if (!Object.keys(row).length) {
        this.brandSelectVisible = false;
        return;
      }
      this.brandSelectVisible = false;
      this.formData.brandName = row.name;
      this.formData.brandId = row.id;
    },
    showBrandDialog() {
      this.brandSelectVisible = true;
    },
    showDialog() {
      this.categorySelectVisible = true;
    },
    stockSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.stockSelectVisible = false;
        return;
      }
      this.stockSelectVisible = false;
      this.formData.scName = row.name;
      this.formData.scId = row.id;
    },
    showStockSelect() {
      this.stockSelectVisible = true;
    },
    onSubmit() {
      this.pageIndex = 1;
      this.tableData = [];
      this.finished = false;
      this.getList();
    },
    onStatusSelectConfirm(val) {
      this.formData.status = val.value;
      this.formData.statusText = val.text;
      this.showStatusPicker = false;
    },
    showSettingPopup(e) {
      e.stopPropagation();
      this.showActions = true;
    },
    rowClick({ row, rowIndex, e }) {
      //进入详情页
      // this.$router.push({
      //   path: "/retail/outDetail/" + row.id,
      // });
    },
    pageChange(pageOptions) {
      this.pageIndex = pageOptions.pageIndex;
      this.pageSize = pageOptions.pageSize;

      this.getList();
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    openDatePicker(key) {
      this.showDatePicker = true;
      this.key = key;
    },
    onConfirm(value) {
      this.formData[this.key] = value;
      this.showDatePicker = false;
    },
    // 跳转变动明细页
    goDetail(item) {
      this.$router.push({
        path: `/stock/lot/detail/${item.lotId || item.id}`,
        query: { productName: item.productName },
      });
    },
    // 打开修改弹窗
    openModify(item) {
      this.modifyForm.id = item.id;
      this.modifyForm.productionDate = item.productionDate || "";
      this.modifyForm.shelfLife =
        item.shelfLife != null ? String(item.shelfLife) : "";
      this.modifyVisible = true;
    },
    openModifyDatePicker() {
      this.showModifyDatePicker = true;
    },
    onModifyDateConfirm(value) {
      this.modifyForm.productionDate = value ? value.split(" ")[0] : "";
      this.showModifyDatePicker = false;
    },
    confirmModify() {
      if (!this.modifyForm.productionDate) {
        Toast.fail("请选择生产日期");
        return;
      }
      if (!this.modifyForm.shelfLife) {
        Toast.fail("请输入保质期天数");
        return;
      }
      this.modifyLoading = true;
      modifyLot({
        id: this.modifyForm.id,
        productionDate: this.modifyForm.productionDate,
        shelfLife: this.modifyForm.shelfLife,
      })
        .then((res) => {
          Toast.success("修改成功");
          this.modifyVisible = false;
          this.onSubmit();
        })
        .finally(() => {
          this.modifyLoading = false;
        });
    },
    getList(load) {
      if (load) {
        this.pageIndex++;
      }
      this.loading = true;
      const params = {
        ...this.formData,
        queryParam: this.queryParam,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      queryLot(params)
        .then((res) => {
          this.loading = false;
          if (load) {
            this.tableData = this.tableData.concat(res.data.datas);
          } else {
            this.tableData = res.data.datas;
          }
          this.totalCount = res.data.totalCount;
          this.totalPage = res.data.totalPage;
          if (this.pageIndex >= this.totalPage) {
            this.finished = true;
          }
        })
        .catch(() => {
          this.finished = true;
          this.loading = false;
        });
      //
      // let params = {};
      // for (const key in this.formData) {
      //   if (Object.prototype.hasOwnProperty.call(this.formData, key)) {
      //     const value = this.formData[key] === "是" ? true : false;
      //     params[key] = value;
      //   }
      // }
      // update(params).then((res) => {
      //
      // });
    },
  },
};
</script>
<style lang="less" scoped>
* {
  touch-action: pan-y;
}
.van-cell {
  padding: 5px 2px 2px 8px !important;
}
::v-deep .color1 {
  color: #333;
}
::v-deep .color2 {
  color: #ee0a24;
}
::v-deep .color3 {
  color: #07c160;
}

.container {
  margin-top: 5px;
  padding: 10px;
  background-color: #fff;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
    span.product-name {
      font-size: 15px;
      font-weight: 600;
      color: #333;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 8px;
    }
    span.actions {
      flex-shrink: 0;
      display: flex;
      gap: 6px;
      .van-button {
        height: 24px;
        line-height: 24px;
        padding: 0 8px;
        font-size: 12px;
      }
    }
  }
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    font-size: 14px;
    .left {
      flex: 5;
      .row {
        display: flex;
        margin-bottom: 10px;
        &.single .item {
          flex: 0 0 100%;
        }
        .item {
          flex: 1;
          display: flex;
          align-items: center;
          font-size: 14px;
          .label {
            color: #333;
            margin-right: 6px;
          }
          .value {
            color: #999;
          }
        }
      }
    }
    .status {
      width: 90px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      flex: 2;
      margin-left: 20px;
      border-radius: 13px 0 0 13px;
      color: #fff;
      overflow: hidden;
      font-size: 14px;
    }
    .color1 {
      background: linear-gradient(83deg, #333, #858585);
    }
    .color2 {
      background: linear-gradient(83deg, red, #bfa98c);
    }
    .color3 {
      background: linear-gradient(83deg, #4c9673, #98bf8c);
    }
  }
}
::v-deep .van-list {
  height: 100%;
  overflow: auto;
}

.modify-content {
  padding: 15px;

  .modify-title {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 15px;
  }

  .modify-actions {
    display: flex;
    gap: 10px;
    margin-top: 15px;
  }
}
</style>
